import { useSessionStore } from '@/store/sessionStore';
import type { QuickFilterMode } from '../-types';

/**
 * Default findings quick-filter view. Client (brand) companies land on the
 * "external" (other companies') findings, everyone else on their own
 * ("internal") findings — mirrors v1 (findings/list/actions.tsx:48-50,
 * `isClientCompany ? 'other-companies' : 'my-company'`).
 *
 * Keys off `isClientCompany`, not `companyType`: the latter is never written
 * (not in the ABOUT template), so it is always empty.
 *
 * Reads the store imperatively so it works in both the component and the
 * route loaders (which run outside React).
 */
export function getDefaultFindingsMode(): QuickFilterMode {
  const isClient = useSessionStore.getState().user?.company?.isClientCompany;
  return isClient ? 'external' : 'internal';
}
